export const DEALER_TICKETS_DEFAULT_PAGE_SIZE = 10;
export const PAGE_OPTIONS = [5, 10, 15, 20, 25, 50, 100];
export const DEFAULT_LANGUAGE_OPTION = { value: 'en', label: 'English' };
export const LANGUAGE_OPTIONS = [
  { value: 'en', label: 'English' },
  { value: 'de', label: 'Deutsch' },
];

export const LANGUAGE_TYPE = 'Language';

export const NOTIFICATION_OPTIONS = [
  { value: 'daily', label: 'Daily' },
  { value: 'weekly', label: 'Every Monday' },
  { value: 'bi-weekly', label: 'Every Two Weeks' },
  { value: 'monthly', label: 'Monthly' },
];

export const ACTIVE_DAYS_OPTIONS = [
  { value: 5, label: '5' },
  { value: 10, label: '10' },
  { value: 15, label: '15' },
  { value: 30, label: '30' },
];

export const SETTINGS_PAGE_OPTIONS = [
  { value: 5, label: '5' },
  { value: 10, label: '10' },
  { value: 15, label: '15' },
  { value: 30, label: '30' },
  { value: 25, label: '25' },
  { value: 50, label: '50' },
  { value: 100, label: '100' },
];
